import {
  EstateWorkItem,
  useEstateInputDataInstance_GetEstateInputDataInstancesByEstateWorkItemIdQuery,
} from 'queries';

import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import EstateWorkItemEstateDetails from './estate-work-item-estate-details';

type EstateWorkItemEstateCellDetailsProps = {
  estateWorkItem: EstateWorkItem;
  handleImpersonateView: (type: string, estateWorkItem: EstateWorkItem) => void;
};

const EstateWorkItemEstateCellDetails = ({
  estateWorkItem,
  handleImpersonateView,
}: EstateWorkItemEstateCellDetailsProps) => {
  const { data: estateInputDataInstancesData, loading: estateInputDataInstancesLoading } =
    useEstateInputDataInstance_GetEstateInputDataInstancesByEstateWorkItemIdQuery({
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      variables: {
        input: {
          estateWorkItemId: estateWorkItem.id,
          portalId: estateWorkItem.estate!.portalId,
          documentGenerationTemplateId: estateWorkItem.documentGenerationTemplateId,
        },
      },
      onError: (e) => {
        showAlert({
          message: 'Error getting estate input data instances by estate work item ID: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  const estateInputDataInstances = estateInputDataInstancesData?.data || [];

  if (estateInputDataInstancesLoading) {
    return <Spinner />;
  }

  return (
    <EstateWorkItemEstateDetails
      estateWorkItem={estateWorkItem}
      estateInputDataInstances={estateInputDataInstances}
      handleImpersonateView={handleImpersonateView}
    />
  );
};

export default EstateWorkItemEstateCellDetails;
